// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;But now you have rejected us and brought us to shame,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and go not out with our armies.<br> </p> </div></div>";
// Exports
module.exports = code;